import _ from 'lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import Icons from '../../../../../common/widgets/Icons';
import { ProductTypes } from '../../../enums';
import { resources } from '../../../resources/resources';
import { showSuccessToast } from '../../../../../common/global/helpers';

interface DiscountAndVoucherInfoProps {
  voucherType: number;
  discount?: string;
  voucherCode?: string;
  voucherUrl?: string;
}
export default function DiscountAndVoucherInfo(
  props: DiscountAndVoucherInfoProps,
) {
  const { t: translate } = useTranslation();
  const { voucherType, discount, voucherCode, voucherUrl } = props;
  const discountSufix =
    voucherType === ProductTypes.CashBack
      ? translate(resources.products.cashbackDiscountSufix)
      : translate(resources.products.voucherDiscountSufix);

  const getDisplayedUrl = (url?: string): string => {
    if (_.isNil(url)) {
      return '';
    }
    if (url.startsWith('https://')) {
      return url.replace('https://', '');
    }

    if (url.startsWith('http://')) {
      return url.replace('http://', '');
    }

    return url;
  };
  return (
    <div className="product-price-box voucher-info">
      {discount && (
        <div className="discount-and-voucher">{`${discount} ${discountSufix}`}</div>
      )}
      {voucherType === ProductTypes.FreeLinkVoucher && (
        <>
          {!_.isNil(voucherCode) && (
            <div className="product-voucher-field">
              <span>{translate(resources.products.voucherCodeLabel)}</span>

              <span className="product-voucher-code">
                {voucherCode}
                <CopyToClipboard text={voucherCode ?? ''}>
                  <button
                    type="button"
                    className="copy-to-clipbboard-btn"
                    onClick={() =>
                      showSuccessToast(translate(resources.clipboardCopied))
                    }
                  >
                    <Icons.CopyClipboardIcon />
                  </button>
                </CopyToClipboard>
              </span>
            </div>
          )}
          {!_.isNil(voucherUrl) && (
            <div className="product-voucher-field">
              <span>{translate(resources.products.voucherWebsiteLabel)}</span>
              <span>{getDisplayedUrl(voucherUrl)}</span>
            </div>
          )}
        </>
      )}
    </div>
  );
}
